<input
    (keydown)="searchKeydown()"
    (keydown.enter)="submitSearch()"
    id="searchboxinput"
    type="search"
    name="searchBar"
    [ngClass]="{ 'center-placeholder': !searchQuery }"
    [(ngModel)]="searchQuery"
    [placeholder]="'Start your search' | translate"
    [value]="searchQuery"
    autocomplete="off"
/>
